import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import DashboardLayout from './layouts/DashboardLayout';
import Dashboard from './pages/Dashboard';
import PollingPercentage from './pages/PollingPercentage';
import ElectedCandidates from './pages/ElectedCandidates';
import PartywiseVoting from './pages/PartywiseVoting';
import SeatsWon from './pages/SeatsWon';
import MaterialsUsed from './pages/MaterialsUsed';
import PopulationReservation from './pages/PopulationReservation';
import ZoneSummary from './pages/ZoneSummary';
import Report from './pages/Report';
import CitizenPortal from './pages/CitizenPortal';
import ExcelUpload from './pages/ExcelUpload';
import LeadershipSelection from './pages/LeadershipSelection';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/citizen" element={<CitizenPortal />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<DashboardLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="zone-summary" element={<ZoneSummary />} />
              <Route path="leadership-selection" element={<LeadershipSelection />} />
              <Route path="report" element={<Report />} />
              <Route path="excel-upload" element={<ExcelUpload />} />
              <Route path="polling-percentage" element={<PollingPercentage />} />
              <Route path="elected-candidates" element={<ElectedCandidates />} />
              <Route path="partywise-voting" element={<PartywiseVoting />} />
              <Route path="seats-won" element={<SeatsWon />} />
              <Route path="materials-used" element={<MaterialsUsed />} />
              <Route path="population-reservation" element={<PopulationReservation />} />
            </Route>
          </Routes>
          <Toaster />
        </BrowserRouter>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;